import React from 'react';
import styled from 'styled-components';
import { Text } from '../../../components';
import { COLORS, device } from '../../../constants';

interface DivProps extends React.HTMLProps<HTMLDivElement> {
  txt: string;
}

export const VertBarElement: React.FC<DivProps> = ({ txt, ...props }) => {
  return (
    <ElementStyle {...props}>
      <Text size={22} color={COLORS.BLACK} text={txt} />
    </ElementStyle>
  );
};

const ElementStyle = styled.div`
  padding-left: 20px;
  border-left: 1px solid ${COLORS.RED_LINE};
  display: flex;
  align-items: center;
  @media screen and ${device.md} {
    > h4 {
      font-size: 18px;
      line-height: 22px;
    }
  }
  @media screen and ${device.sm} {
    border-left: none;
    padding-left: 0;
    border-bottom: 1px solid ${COLORS.RED_LINE};
    padding-bottom: 10px;
    > h4 {
      font-size: 14px;
      line-height: 18px;
    }
  }
`;
